/**
 * P3-1 投流大盘
 *
 * 顶部 4 卡：本月线索 / 关联客户 / 成交单数 / 营收
 * 待分配线索（manager 视角）
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { $ } from '../../lib/api';
import {
  PageHeader, StatsRow, StatCard, HomeCard, Pill, TableWrap,
} from '../../components/ui';
// ux9 日期统一出口
import { fmtRelative } from '../../lib/format';

export function MarketingDashboardPage() {
  const { data: summary } = useQuery<any>({
    queryKey: ['marketing/dashboard/summary'],
    queryFn: () => $.get('/marketing/dashboard/summary'),
  });
  const { data: pending } = useQuery<any>({
    queryKey: ['marketing/leads/pending'],
    queryFn: () => $.get('/marketing/leads', { status: 'pending', pageSize: 20 }),
    refetchInterval: 10_000,
  });
  const items = pending?.items ?? [];

  return (
    <>
      <PageHeader
        breadcrumb={['投流', '大盘']}
        title="投流 ROI 大盘"
        subtitle="月度线索 / 转化 / 营收 / 待分配队列"
      />
      <div className="work-content">
        <StatsRow>
          <StatCard label="本月线索" value={summary?.monthLeads ?? 0} unit="条" />
          <StatCard label="关联客户" value={summary?.monthMatched ?? 0} unit="个"
                    valueColor="primary" />
          <StatCard label="本月成交" value={summary?.monthDeals ?? 0} unit="单"
                    valueColor="success" />
          <StatCard label="本月营收"
                    value={Number(((summary?.monthRevenue ?? 0) / 10000).toFixed(1))}
                    prefix="¥" suffix="万"
                    valueColor="success" />
        </StatsRow>

        <HomeCard title={`待分配线索（${items.length}）`}>
          <TableWrap>
            <table className="ck-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ width: '12%' }}>到达时间</th>
                  <th style={{ width: '8%' }}>意向</th>
                  <th>客户画像</th>
                  <th>AI 推荐 Top 3</th>
                  <th style={{ width: '14%' }}></th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 && (
                  <tr><td colSpan={5} style={{ padding: 24, textAlign: 'center', color: 'var(--text-3)' }}>
                    🎉 当前没有待分配线索
                  </td></tr>
                )}
                {items.map((l: any) => {
                  const rec = (l.aiRecommendedUsersJson as any[]) ?? [];
                  return (
                    <tr key={l.id}>
                      <td>{fmtRelative(l.receivedAt)}</td>
                      <td>{l.aiIntentStars ? '⭐'.repeat(l.aiIntentStars) : '—'}</td>
                      <td>{l.aiProfileSummary ?? l.nickName ?? '—'}</td>
                      <td style={{ fontSize: 12 }}>
                        {rec.slice(0, 3).map((r: any, i: number) => (
                          <Pill key={i} tone={i === 0 ? 'success' : 'default'}>
                            {r.name ?? '#' + r.user_id}
                          </Pill>
                        ))}
                      </td>
                      <td>
                        <Link to={`/marketing/leads/${l.id}`}
                              style={{
                                padding: '4px 10px', background: 'var(--primary)', color: '#fff',
                                borderRadius: 4, fontSize: 12, textDecoration: 'none',
                              }}>
                          去分配 →
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </TableWrap>
        </HomeCard>
      </div>
    </>
  );
}
